(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return; // content already visible via CSS fallback

  if (!('IntersectionObserver' in window)) return; // no-op fallback, content stays visible

  function init() {
    var sections = document.querySelectorAll('main .shopify-section');
    if (!sections.length) return;

    // Skip the first content section (usually the hero) so above-the-fold content
    // never has to wait on a scroll event to become visible.
    sections.forEach(function (section, index) {
      if (index === 0) return;
      section.classList.add('tkm-reveal');
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tkm-in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    sections.forEach(function (section, index) {
      if (index === 0) return;
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
